import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config";

interface AdminUser {
    id: number;
    username: string;
}

export default function AdminUsers() {
    const [admins, setAdmins] = useState<AdminUser[]>([]);

    useEffect(() => {
        fetchAdmins();
    }, []);

    const fetchAdmins = async () => {
        const response = await fetch(`${API_BASE_URL}/admin/users`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` },
        });
        const data = await response.json();
        setAdmins(data);
    };

    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold mb-4">Manage Admins</h2>
            <ul className="space-y-4">
                {admins.map((admin) => (
                    <li key={admin.id} className="border p-4 rounded shadow">
                        <h3 className="text-lg font-bold">{admin.username}</h3>
                    </li>
                ))}
            </ul>
        </div>
    );
}
